import { Select } from "antd";
import { FaCheck } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { RiTimeZoneFill } from "react-icons/ri";
import { LogoSvgFull } from "../../assets/icons/LogoSvgFull";
import {
  TDeviceBrandDropItem,
  TDeviceModelDropItem,
  TPlanDropItem,
} from "../../types/types";
import { PaymentPlanIconSvg } from "./svg";

const { Option } = Select;

function PlanDropDown({
  options,
  state,
  setState,
  setPlanCost,
  placeholder,
  readOnly,
}: {
  state: string | undefined;
  setState: (value: string) => void;
  options: TPlanDropItem[] | TDeviceBrandDropItem[] | TDeviceModelDropItem[];
  setPlanCost: (value: number) => void;
  placeholder: string;
  readOnly?: boolean;
}) {
  const handleChange = (value: string) => {
    const getPlanCost = options.filter((option) => value === option._id);
    setPlanCost((getPlanCost[0] as TPlanDropItem).fullPaymentAmount || 0);
    setState(value);
  };

  return (
    <Select
      defaultValue={state}
      value={state}
      style={
        {
          // width: 133,
          // height: 40,
        }
      }
      disabled={readOnly}
      placeholder={placeholder}
      onChange={handleChange}
      variant="borderless"
      className="Nunito !border-[#D1D5DB] !border-[1px] !bg-[#F9FAFB] rounded-[8px] !w-full !h-[44px] !font-[300] text-[16px] "
      suffixIcon={<IoIosArrowDown className="text-[20px] text-black Nunito " />}
    >
      {options.map((datum, index) => {
        return (
          <Option key={index} value={datum._id} className="!p-2 ">
            <div className="flex items-center justify-between w-full">
              <div className="flex w-full items-center gap-[5px] truncate">
                {placeholder === "Device brand" ? (
                  <img
                    className="w-[18px]"
                    loading="lazy"
                    src={(datum as TDeviceBrandDropItem).brandLogo}
                    alt="brand Logo"
                  />
                ) : placeholder === "Device model" ? (
                  <img
                    className="w-[18px] "
                    loading="lazy"
                    src={(datum as TDeviceModelDropItem).brand.brandLogo}
                    alt="brand Logo"
                  />
                ) : (
                  <PaymentPlanIconSvg className="min-h-[18px] min-w-[18px] max-h-[18px] max-w-[18px]" />
                )}
                {placeholder === "Device brand"
                  ? (datum as TDeviceBrandDropItem).brandName
                  : placeholder === "Device model"
                    ? (datum as TDeviceModelDropItem).modelName
                    : (datum as TPlanDropItem).planName}
              </div>

              {state === datum._id && (
                <FaCheck className="check text-brand-darkYellow text-[16px] " />
              )}
            </div>
          </Option>
        );
      })}
    </Select>
  );
}

export default PlanDropDown;
